import { Component, OnInit } from '@angular/core';
import { ApiService } from '../../../../services/main/api.service';
import { NgbModal, ModalDismissReasons, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import Swal from 'sweetalert2';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Storage } from '@ionic/storage';
import { Router, ActivatedRoute } from '@angular/router';
import { Global } from '../../../../services/global';
import { BaseCrudComponent } from '../../../base-crud/base-crud.component';
import { TranslateService } from '@ngx-translate/core';

import { Observable, from, of, concat } from 'rxjs';
import { mergeMap, catchError, timeout, retry, debounceTime, distinctUntilChanged, map } from 'rxjs/operators';

@Component({
  selector: 'app-materialgroup',
  templateUrl: './materialgroup.component.html',
  styleUrls: ['./materialgroup.component.css']
})
export class MaterialgroupComponent extends BaseCrudComponent {

    translations: any;
    listMaterials: any;
    loadingRequired: any;
    
    constructor(
        srv: ApiService,
        modalService: NgbModal,
        storage: Storage,
        router: Router,
        private route: ActivatedRoute,
        public translate: TranslateService
    ) {
        super(srv, modalService, storage, router);

        this.read_url = 'Product/Discount/MaterialGroup/All';
        this.create_url = 'Product/Discount/MaterialGroup/Save';
        this.update_url = 'Product/Discount/MaterialGroup/Save';
        this.delete_url = 'Product/Discount/MaterialGroup/LogicalDelete';
        this.search_fields = ['code', 'description'];
        this.loadingRequired = false;

        this.reload.subscribe(val => {
            if (val) {
                super.clearData();
                this.getList();
            }
        });
    }

    ngOnInit() {
        this.translate.getTranslation(this.translate.currentLang)
            .subscribe((translations) => {
                this.translations = translations;
                super.ngOnInit();
                this.getList();
            });
    }

    public getFiltersData() {
        var par_url = 'Product/Discount/MaterialGroup';

        return this.srv.getCall(par_url).pipe(
            mergeMap(x => {
                let mydata: any = { status: false, message: '', data: [] };
                mydata = x;

                if (mydata.status == true) {
                    return of(mydata.data);
                }
                else {
                    return of(false);
                }
            }),
            //timeout(MAX_TIME),
            catchError(data => of(false))
        );
    }

    openCreateModal(content: any) {
        this.c_obj = {};
        this.listMaterials = [];

        super.openCreateModal(content);
        this.loadingRequired = true;
        this.getFiltersData().subscribe(d => {
            this.loadingRequired = false;
            if (d != false) {
                this.listMaterials = d;
            }
        });
    }

    openUpdateModal(content: any, obj: any) {
        this.u_obj = {};
        this.listMaterials = [];
        super.openUpdateModal(content, obj);

        this.loadingRequired = true;

        this.getFiltersData().subscribe(d => {
            this.loadingRequired = false;
            if (d != false) {
                this.listMaterials = d;
                this.u_obj['code'] = null;
                var ref = this;

                if( (obj['code'] != undefined) && (obj['code'] != null) ){
                  let tmp = this.listMaterials.filter(r => r.code == obj['code']);
                  if( tmp.length > 0 ){
                    ref.u_obj['code'] = tmp[0];
                  }
                }
            }
        });
    }

    validateCreateInfo(fields: any) {
        let mygroup: any = {};
        mygroup = new FormGroup({
            'code': new FormControl(fields.code, [Validators.required])
        });

        return mygroup.valid;
    }

    validateUpdateInfo(fields: any) {
        let mygroup: any = {};
        mygroup = new FormGroup({
            'code': new FormControl(fields.code, [Validators.required])
        });

        return mygroup.valid;
    }

    public createItem(content: any, form: any) {
        var validated = true;

        if (form == undefined) {
            form = {};
        }
        //console.log(form);
        validated = this.validateCreateInfo(form);
      

        if (!validated) {
            Swal.fire(this.translations['msg_all_required'], '', 'error');
            return;
        }

        var to: any;
        to = {};
        to.code = form['code']['code'];
        
        var qst = this.create_url;
        this.isCreating = true;

        this.srv.postCall(qst, to).subscribe(x => {
            this.isCreating = false;
            if (x.status) {
                this.c_obj = {};
                this.getList();
                this.closeModal(content);
                Swal.fire(this.translations.created, '', 'success');
            }//end success
            else {
                //Swal.fire(this.translations[x.msg], '', 'error');
                Swal.fire(x.message, '', 'error');
            }
        });
    }

    public updateItem(content: any, form: any) {
        var validated = true;

        if (form == undefined) {
            form = {};
        }

        validated = this.validateUpdateInfo(form);
        if (!validated) {
            Swal.fire(this.translations['msg_all_required'], '', 'error');
            return;
        }

        var to: any;
        to = {};
        to.code = form['code']['code'];

        var qst = this.update_url;
        this.isUpdating = true;

        this.srv.postCall(qst, to).subscribe(x => {
            this.isUpdating = false;
            if (x.status) {
                this.getList();
                this.closeModal(content);
                Swal.fire(this.translations['updated'], '', 'success');
            }//end success
            else {
                Swal.fire(x.message, '', 'error');
                //this.closeModal(content);
            }
        });
    }


}
